// extracted by mini-css-extract-plugin
export default {"dropzoneOpenCard":"ZIuh8oeHthnyD_FJZVa8","textContainer":"mHuxNAAaChsRG8uKxIPU","uploadIcon":"qFo2qCqHwE94u8QD8HVV"};